<template>
  <div>
    <div class="pull-left d-block w-100">
      <div id="three-icon-loading" class="loader" :class="{ hidden: !loading }">
        <div class="loading-icons">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="w-100 text-semibold">{{ $t('common.loading') }}</div>
      </div>

      <div v-if="errors.has('conflicts')" class="alert alert-error">
        <p>{{ errors.getString('conflicts') }}</p>
        <p v-html="$t('common.error')"></p>
      </div>

      <div class="pb-title-row d-flex flex-row gap-2 justify-content-between align-items-baseline">
        <h2 class="pb-title mb-0 fs-5 d-flex flex-row gap-1 align-items-baseline">
          {{ item.title }}
          <span class="tip" data-placement="top" title="" :data-bs-title="tooltip" data-bs-toggle="tooltip">
            <i class="fa fa-info-circle"></i>
          </span>
        </h2>
        <div class="d-flex flex-row gap-2 align-items-center">
          <div class="d-flex flex-column gap-1 align-items-end">
            <div class="price fs-5">${{ price }}</div>

            <div v-if="discount != 0" class="pb-discount text-right pe-0">
              <span class="amount">${{ item.subtotal.toFixed(2) }}</span>
              <span v-if="getFirstYearDiscountedPrice(item.term)" class="bundle">First year ${{ getFirstYearDiscountedPrice(item.term) }}</span>
              <span class="savings">{{ $t('registration_domain.you_saved') }} ${{ item.discount }}!</span>
            </div>
          </div>
          <button class="delete btn btn-xs btn-flat btn-outline btn-danger pr-lg" @click="remove(item.id)">
            <i v-track="{ category: 'plan-builder', action: 'click', label: product_config.tracking_removal_label }" type="button" class="fa fa-remove"></i>
          </button>
        </div>
      </div>

      <div class="pb-terms pb-grey-bck ps-4 pe-4 pt-3 pb-3">
        <span class="text-semibold pb-2 pull-left d-block w-100">{{ $t('common.includes') }}:</span>
        <span class="pb-2 pull-left d-block w-100" v-for="(inclusion, idx) in inclusions" :key="idx">
          {{ inclusion }}
        </span>
      </div>
      <br />
      <div v-for="(addons, key) in item.suggested_addons || {}" :key="key">
        <addon-configuration :item="item" :suggested_addons="addons" :addon_name="key" :loading.sync="loading" />
      </div>
      <domain-input v-if="product_config.domain_input" :cart_error="errors.has('domain') ? errors.getString('domain') : ''" :item="item" :loading.sync="loading" />
      <div v-if="is_monthly">
        <monthly-term-selector v-if="product_config.term_selection" :item="item" :loading.sync="loading" />
      </div>
      <div v-else>
        <term-selector v-if="product_config.term_selection" :item="item" :loading.sync="loading" :globalTerm="globalTerm" />
      </div>
      <quantity-selector v-if="!is_monthly && product_config.quantity_selection" :item="item" :loading.sync="loading" />
      <privacy-upsell v-if="product_config.privacy_upsell" :item="item" />
    </div>
    <hr class="collect-hr" />
  </div>
</template>

<script>
import RemoveItem from '../../mixins/RemoveItem';
import ProductConfigs from './product_configs';
import TermSelector from '../TermSelector';
import MonthlyTermSelector from '../MonthlyTermSelector';
import DomainInput from '../DomainInput';
import PrivacyUpsell from '../PrivacyUpsell';
import AddonConfiguration from '../AddonConfiguration.vue';
import { mapActions } from 'vuex';

export default {
  name: 'Product',

  mixins: [RemoveItem],

  components: {
    DomainInput,
    TermSelector,
    MonthlyTermSelector,
    PrivacyUpsell,
    AddonConfiguration
  },

  props: {
    item: {
      type: Object,
      required: true,
      validator: function (value) {
        return value !== null && typeof value === 'object' && typeof value.suggested_addons === 'object';
      }
    },
    globalTerm: {
      required: true,
      default: false
    },
    errors: {
      type: Object,
      required: false,
      default: () => {}
    },
    inclusions: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    product_config: function () {
      return ProductConfigs[this.item.product_id];
    },
    discount: function () {
      return this.item.discount ? this.item.discount : 0;
    },
    price: function () {
      var price = this.item.subtotal - this.discount;
      return price.toFixed(2);
    },
    tooltip: function () {
      let product_id = this.item.product_id.split('.').join('_');
      return this.$t(product_id + '.tooltip');
    },
    is_monthly: function () {
      return Object.prototype.hasOwnProperty.call(this.item, 'has_monthly_term_type') && this.item.has_monthly_term_type;
    }
  },

  methods: {
    ...mapActions('cart', ['updateProduct', 'removeAddOnItem', 'addCartItem']),
    getFirstYearDiscountedPrice(term) {
      if (this.item.first_term_discounts === undefined || !(term in this.item.first_term_discounts)) {
        return '';
      }

      const discounted_price = this.item.price - this.item.first_term_discounts[term];
      return discounted_price.toFixed(2);
    }
  }
};
</script>
